import { useMemo } from 'react'
import { pendingStatuses } from '../utils/statuses'

type PropType = {
    mode: 'preview' | 'editing' | 'creating'
    item: Record<string, unknown>
}

const useDisableInput = ({ mode = 'preview', item }: PropType) => {
    const disableAllInputs = useMemo(() => {
        if (mode === 'preview') return true
        if (item && pendingStatuses.includes(item.status || item.registration_status)) return true

        return false
    }, [mode, item])

    const disableOnEditing = useMemo(() => {
        if (mode === 'preview') return true
        if (item) return true

        return false
    }, [mode, item])

    return {
        disableAllInputs,
        disableOnEditing
    }
}

export default useDisableInput
